import { render, staticRenderFns } from "./SettingsP1Integration.vue?vue&type=template&id=b7d440f2&"
import script from "./SettingsP1Integration.vue?vue&type=script&lang=js&"
export * from "./SettingsP1Integration.vue?vue&type=script&lang=js&"
import style0 from "./SettingsP1Integration.vue?vue&type=style&index=0&id=b7d440f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports